export const styleSheet = theme => ({
    container: {
        textAlign: 'center',
        color: theme.colors.gray04,
        margin: '8px 0',
        letterSpacing: 1
    }
});
